<template>
  <div class="menu-wrapper">
    <div
      :class="['item',item.activate?'on':'off']"
      v-for="(item,idx) in arr"
      @click="tabClick(idx)"
      :key="idx"
    >
      <img
        :src="item.activate?item.imgOn:item.imgUn"
        @mouseover="mouseOver(idx)"
        @mouseout="mouseOut(idx)"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'menuright',
  data () {
    return {
      arr: [
        {
          imgOn: require('../assets/about_us_white.png'),
          imgUn: require('../assets/about_us.png'),
          activate: false
        },
        {
          imgOn: require('../assets/contact_us_white.png'),
          imgUn: require('../assets/contact_us.png'),
          activate: false
        },
        {
          imgOn: require('../assets/down_app_white.png'),
          imgUn: require('../assets/down_app.png'),
          activate: false
        },
        {
          imgOn: require('../assets/totop_white.png'),
          imgUn: require('../assets/totop.png'),
          activate: false
        }
      ]
    };
  },
  methods: {
    tabClick (index) {
      this.$emit('tabclick', index)
    },
    mouseOver (idx) {
      this.arr[idx].activate = true
      if(idx===2){
          this.$emit('showcode', true)
      }
    },
    mouseOut (idx) {
      this.arr[idx].activate = false
      if(idx===2){
          this.$emit('showcode', false)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.menu-wrapper {
  width: 70px;
}

.menu-wrapper .item {
  margin-bottom: 10px;
  width: 70px;
  height: 70px;
  text-align: center;
  cursor: pointer;
}

.menu-wrapper .on {
  background: #dc371b;
}

.menu-wrapper .off {
  background: rgb(243, 243, 243);
}

.menu-wrapper img {
  width: 50px;
  height: 50px;
  margin-top: 10px;
}
</style>
